<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="quest-results-table"
            v-if="filteredUsers.length"
            :fields="filteredUsersTableFields"
            :items="filteredUsers"
            :sort-compare="sortCompare">
            <template #options>
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="groupSelected"
                    :options="groupOptions"></b-form-select>
            </template>

            <template #cell(results)="row">
                <b-button
                    class="btn-review"
                    v-b-tooltip.hover
                    v-if="needsReview(row.item.quest_missions)"
                    :title="$t('quest.check')"
                    variant="warning-icon-only"
                    @click="onShow(row.item.id)">
                    <i class="fa fa-hourglass fa-fw"></i>
                </b-button>

                <b-button
                    class="btn-open"
                    v-b-tooltip.hover
                    v-else
                    variant="primary-icon-only"
                    @click="onShow(row.item.id)"
                    :title="$t('common.view')">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-quest-list"
            v-else>
            <div class="header">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="groupSelected"
                    :options="groupOptions"></b-form-select>
            </div>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('quest.no_results_found_to_check') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-review-table-component',
    props: ['groupId', 'groups', 'users', 'questId'],
    data() {
        var groupOptions = [];
        this.groups.forEach((obj) => {
            groupOptions.push({ value: obj.id, text: obj.name });
        });
        return {
            groupOptions: groupOptions,
            groupSelected: this.groups[0].id,
            list: [],
            id: null,
            filteredUsersTableFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'results',
                    label: this.$t('quest.results'),
                    sortable: true,
                },
            ],
            rapportTableColumns: ['full_name', 'results'],
            rapportTableOptions: {
                headings: {
                    full_name: this.$t('common.name'),
                    results: this.$t('quest.results'),
                },
                sortable: ['full_name', 'results'],
                filterable: ['full_name'],
                saveState: true,
                sortIcon: {
                    is: 'fa-sort',
                    base: 'fas',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                customSorting: {
                    full_name: function (ascending) {
                        return function (a, b) {
                            let textA = a.surname.toUpperCase();
                            let textB = b.surname.toUpperCase();

                            if (ascending) return textA >= textB ? 1 : -1;

                            return textA <= textB ? 1 : -1;
                        };
                    },
                    results: function (ascending) {
                        return function (a, b) {
                            let aReview = false;
                            let bReview = false;

                            a.quest_missions.forEach((usermission) => {
                                if (usermission.status == 2) aReview = true;
                            });

                            b.quest_missions.forEach((usermission) => {
                                if (usermission.status == 2) bReview = true;
                            });

                            if (ascending) return aReview == true ? 1 : -1;

                            return aReview == false ? 1 : -1;
                        };
                    },
                },
            },
        };
    },
    methods: {
        onShow(user_id) {
            window.location.href = '/quest/rapport/' + this.questId + '/user/' + user_id;
        },
        needsReview(usermissions) {
            if (usermissions == null || usermissions.lenght == 0) return false;

            var needsReview = false;
            usermissions.forEach((usermission) => {
                if (usermission.status == 2) needsReview = true;
            });

            return needsReview;
        },

        sortCompare: function sortCompare(firstRow, secondRow, key) {
            if (key === 'results' && firstRow[key] && secondRow[key]) {
                return firstRow[key] < secondRow[key] ? -1 : firstRow[key] > secondRow[key] ? 1 : 0;
            } else {
                return false;
            }
        },
    },
    computed: {
        filteredUsers() {
            let users = this.users.filter((user) => {
                if (this.groupSelected != null) {
                    var mainGroup = false;
                    var groupSelected = this.groupSelected;
                    this.groups.forEach((obj) => {
                        if (obj.parent_id == null && groupSelected == obj.id) mainGroup = true;
                    });

                    if (mainGroup) return true;

                    if (user.group_id != this.groupSelected) return false;
                }

                return true;
            });

            users = users.map((user) => {
                if (this.needsReview(user.quest_missions)) {
                    return {
                        ...user,
                        results: 2,
                    };
                } else {
                    return {
                        ...user,
                        results: 1,
                    };
                }
            });

            return users;
        },
    },
};
</script>

<style scoped lang="scss"></style>
